<template>
  <div class="page_content" aria-label="Scorm Upload Page Content">

      <div class="hidden-container">
        <form method="POST" id="multipleFileUploadForm" enctype="multipart/form-data" v-on:submit.prevent>
          <input type="file" id="fileListId" ref="fileInput" name="fileList" rel="multipleFile" @change="fileToBeUploaded" aria-label="select file" />
        </form>
      </div>
      <div class="row page-heading">
        <div class="col-7 input module_heading" role="heading" aria-level="1">
          <span class="module_icon icon-scorm"> </span>
          <span class="module_type_name">Scorm Upload</span>
       </div>
       <div class="col-5 btn_container">
        <b-btn @click="uploadScormClicked" aria-label="upload">upload</b-btn>
          <b-btn @click="returnToDashboard" aria-label="cancel">cancel</b-btn>
       </div>
    </div>

    <div class="create-section">
        <div class="content-section">
        <div class="row content-row pt-4">
          <div class="col-6 row">
            <div class="col-4 form-label">
              <label class="label" for="scormOwningLibrary">Add to Folder</label>
            </div>
            <div class="col-8">
              <select id="scormOwningLibrary" v-model="selectedFolder">
                    <option v-for="learningSpace in learningSpaces" v-bind:value="learningSpace">
                      {{ learningSpace.displayName }}
                    </option>
                 </select>
            </div>
          </div>
          <div class="col-6 row">
            <div class="col-4 form-label">
              <label class="label" for="chooseFileButton">Select file</label>
            </div>
            <div class="col-8">
              <b-btn id="chooseFileButton" @click="chooseFileClicked">Choose File</b-btn>
              <span class="selected-file-name" v-if="fileUploadArray.length > 0">{{fileUploadArray[0].fileName}}</span>
                <span class="selected-file-name" v-else>No file chosen</span>
            </div>
          </div>
        </div>

     </div>
    </div>

    <div class="modal_container modal_alart">
      <b-modal class="" ref="uploadErrorModal" :title="'Error Message!'" :header-bg-variant="'competency-upload-exists-modal'" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
          <div class="text-center">
            <span v-html="errorMessage"></span>
          </div>
        <div slot="modal-header" class="header-section">
          <div class="ic ic-hd"></div>
          <div class="head_txt">Error Message!</div>
          <button type="button" class="btn_close" @click="hideUploadErrorModal" aria-label="close">
            <span class="ic-close"></span>
          </button>
        </div>
        <div slot="modal-footer" class="w-100">
            <b-button @click="hideUploadErrorModal" class="btn button-primary float-right mr-2" aria-label="no"> ok </b-button>
        </div>
      </b-modal>
    </div>

    <div class="modal_container modal_alart success">
      <b-modal class="" ref="uploadSuccessModal" :title="'Upload Completed!'" :header-bg-variant="'competency-upload-exists-modal'" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
          <div class="text-center">
              <span> Scrom file Successfully uploaded.</span>
          </div>
        <div slot="modal-header" class="header-section">
          <div class="ic ic-hd"></div>
          <div class="head_txt">Upload Completed!</div>
          <button type="button" class="btn_close" @click="hideUploadSuccessModal" aria-label="close">
            <span class="ic-close"></span>
          </button>
        </div>
        <div slot="modal-footer" class="w-100">
            <b-button @click="returnToDiscover" class="btn button-primary float-right mr-2" aria-label="no"> ok </b-button>
        </div>
      </b-modal>
    </div>
    <div class="loading-spinner">
        <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
            <div class="text-center" style="color: #FFF">
                <i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
            </div>
        </b-modal>
    </div>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import _ from 'lodash'
import Papa from 'papaparse'

var isScormFile = function (file) {
  var fileName = file.name
  var regEx = /(.zip)$/i
  return regEx.test(fileName)
}

var getFileName = function (fileName) {
  if (!fileName && fileName !== null) {
    return null
  }
  return fileName.replace(/\.\w+$/g, '')
}

var getUpdatedFileName = function (title, fileName) {
  var ext = fileName.substr((~-fileName.lastIndexOf('.') >>> 0) + 2)
  if (ext !== '' || ext !== null) {
    return (title + '.' + ext)
  } else {
    return fileName
  }
}

var FileObject = function (title, file, size, timestamp, type) {
  this.title = getFileName(title)
  this.file = file
  this.fileName = getUpdatedFileName(this.title, title)
  this.size = size
  this.contentFileType = type
  this.timestamp = timestamp
  this.id = timestamp
}

export default {
  name: 'event-upload',
  props: [],
  data: () => {
    return {
      fileUploadArray: [],
      institutionId: '',
      userId: '',
      selectedFolder: {},
      errorMessage: ''
    }
  },
  mounted () {
    this.loadDataForScormUpload()
  },

  methods: {
    ...mapActions([
      'uploadScormFile',
      'loadLibrariesForUser',
      'loadPermission'
    ]),
    loadDataForScormUpload () {
      let userObj = JSON.parse(localStorage.getItem('userobj'))
      this.userId = userObj.uuid
      this.institutionId = userObj.institutionId
      this.loadPermission()
      this.loadLibrariesForUser(this.userId).then((response) => {
        if (response && response.length >= 1) {
          this.selectedFolder = response[0]
        }
      })
    },
    uploadScormClicked () {
      if (this.fileUploadArray.length <= 0) {
        this.$notify({
          group: 'notify',
          type: 'warn',
          title: '',
          text: 'Please upload a valid file to upload scorm.'
        })
        return
      }
      this.uploadFiles()
    },
    cancelUploadClicked () {
      this.fileUploadArray = []
    },
    chooseFileClicked () {
      this.clearFilePath()
      let sel = 'rel=multipleFile'
      $('input[type=file][' + sel + ']').click()
    },
    fileToBeUploaded (ev) {
      var files = ev.target.files || ev.dataTransfer.files
      if (!files.length) {
        return
      }
      if (!isScormFile(files[0])) {
        this.clearFilePath()
        this.errorMessage = 'Please Select Valid Scrom zip file'
        this.$refs.uploadErrorModal.show()
        return
      }
      this.prepareFileUploadArray(files)
    },
    prepareFileUploadArray (files) {
      if (files) {
        var timestamp = new Date().getTime()
        for (var i = 0; i < files.length; i++) {
          timestamp = timestamp + i
          this.addFileToUploadArray(files[i], timestamp)
        }
      }
    },
    addFileToUploadArray (newFile, timestamp) {
      var isFound = _.find(this.fileUploadArray, function (file) {
        return ((newFile.name === file.title) && (newFile.size === file.size))
      })

      if (!isFound) {
        this.fileUploadArray.push(new FileObject(newFile.name, newFile, newFile.size, timestamp, newFile.type))
      }
    },
    uploadFiles () {
      if (this.fileUploadArray.length <= 0) {
        return
      }
      let fileObject = this.fileUploadArray[0]
      this.readCsvFileAndShowWarningIfExists(fileObject)
    },
    readCsvFileAndShowWarningIfExists (fileObject) {
      let self = this
      let data = new FormData()
      data.append('scormZipFile', fileObject.file, fileObject.title)
      this.$refs.loadingModal.show()
      this.uploadScormFile({owningLibraryId: self.selectedFolder.uuid, fileData: data}).then(response => {
        this.$refs.loadingModal.hide()
        this.fileUploadArray = []
        if(response.status == 'success'){
            this.showUploadSuccessModal()
        }else{
             this.errorMessage = 'Unable to process scrom file, please check the file format.'
             this.$refs.uploadErrorModal.show()
        }

      })
    },
    returnToDiscover () {
      this.$refs.uploadSuccessModal.hide()
      return this.$router.push('/discover')
    },
    hideUploadErrorModal () {
      this.$refs.uploadErrorModal.hide()
      this.errorMessage = ''
      this.clearFilePath()
    },
    showUploadSuccessModal () {
      this.$refs.uploadSuccessModal.show()
    },
    hideUploadSuccessModal () {
      this.$refs.uploadSuccessModal.hide()
      this.errorMessage = ''
      this.clearFilePath()
    },
    clearFilePath () {
      this.fileUploadArray = []
      const input = this.$refs.fileInput
      input.type = 'text'
      input.type = 'file'
    },
    returnToDashboard () {
      this.$refs.uploadSuccessModal.hide()
      let userPermission = this.permission.userPermission
      if (userPermission.studentHomeView) {
        return this.$router.push({ name: 'studentDashboard' })
      } else if (userPermission.employerAdminHomeView) {
        return this.$router.push({ name: 'employerAdmin' })
      } else if (userPermission.advisorHomeView) {
        return this.$router.push({ name: 'advisorDashboard' })
      } else if (userPermission.instructorHomeView) {
        if (userPermission.adminHomeView) {
          return this.$router.push({ name: 'adminDashboard' })
        } else {
          return this.$router.push({ name: 'instructorDashboard' })
        }
      }
    }
  },
  computed: {
    ...mapState({
      'permission': state => state.user.permission,
      'learningSpaces': state => state.assessment.learningSpaces
    })
  },
  watch: {
  }
}
</script>

<style scoped>
.hidden-container {
  visibility: hidden;
  height: 1px;
}
</style>



// WEBPACK FOOTER //
// src/app/learningContent/components/ScormUpload.vue